<template>
  <rl-carousel v-model="slide">
    <div slot-scope="{ wrapperStyles, slides: { count, active, moveTo } }">
      <div class="overflow-hidden">
        <div v-bind="wrapperStyles" class="w-full">
          <slot></slot>
        </div>
      </div>
      <div class="absolute w-full pin-b flex items-end justify-end pr-8 pb-8">
        <div
          v-for="(item, index) in count"
          :key="index"
          @click="
            slide = index
            autoscroll = false
          "
          class="mb-2 mr-2 p-1 cursor-pointer text-center"
          :class="{ active: active === index }"
        >
          <span
            :class="{
              'text-grey text-base': active !== index,
              'text-2xl active': active === index
            }"
          >
            {{ item }}
          </span>
        </div>
      </div>
    </div>
  </rl-carousel>
</template>

<script>
import { RlCarousel } from 'vue-renderless-carousel'

export default {
  name: 'number-carousel',
  components: {
    RlCarousel
  },
  data() {
    return {
      slide: 0,
      autoscroll: -2000
    }
  }
}
</script>

<style lang="less" scoped>
div.active {
  background-color: #666;
  border-radius: 5px;
  transition: all 0.5s ease;
  transition-property: background-color, width, height;
}
span {
  transition: color 0.5s ease, font-size 0.5s ease;

  &.active {
    color: white;
  }
}
</style>
